// Aviso de prenda añadida.
//
// Se cuelga de `cart:update`, que ya dispara la ficha de producto al meter algo
// en la cesta. Por eso este archivo no toca nada del carrito: si mañana cambia
// cómo se añade, esto sigue funcionando mientras el evento se siga mandando.

const ESPERA = 6000;   // lo que se queda solo antes de irse
const POCAS = 3;       // a partir de aquí «quedan pocas» deja de ser informar

const pesos = (centavos) => {
  const n = Number(centavos);
  if (!Number.isFinite(n)) return '';
  return `RD$ ${(n / 100).toLocaleString('es-DO', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
};

// Shopify sirve las fotos con un ancho al gusto. Se pide justo la que cabe en
// el hueco, en vez de bajar la original de 2000px para pintarla a 70.
function aMedida(url, ancho = 210) {
  if (!url) return '';
  try {
    const u = new URL(url, location.origin);
    u.searchParams.set('width', String(ancho));
    return u.toString();
  } catch {
    return url;
  }
}

class AvisoAnadida extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('.sc-added__panel');
    for (const b of this.querySelectorAll('[data-cerrar]')) {
      b.addEventListener('click', () => this.esconder());
    }

    // Con el ratón encima no se va: alguien que lo está leyendo no quiere que
    // se le escape a mitad.
    this.panel?.addEventListener('pointerenter', () => clearTimeout(this.reloj));
    this.panel?.addEventListener('pointerleave', () => this.programarCierre());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this.hidden) this.esconder();
    });

    document.addEventListener('cart:update', (e) => this.mostrar(e.detail));
  }

  async mostrar(detalle = {}) {
    const item = detalle.item;
    if (!item) return;                       // un refresco del carrito, no una añadida

    const q = (sel) => this.querySelector(sel);

    const foto = q('[data-foto]');
    const url = aMedida(item.image || item.featured_image?.url);
    if (url) {
      foto.src = url;
      foto.alt = item.product_title || '';
      foto.hidden = false;
    } else {
      foto.hidden = true;
    }

    q('[data-titulo]').textContent = item.product_title || item.title || '';

    // «Default Title» es lo que pone Shopify cuando la prenda no tiene tallas.
    // Enseñarlo sería enseñar la tripa del sistema.
    const variante = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    const vNodo = q('[data-variante]');
    vNodo.textContent = variante;
    vNodo.hidden = !variante;

    const cuantas = Number(item.quantity) || 1;
    q('[data-precio]').textContent = cuantas > 1
      ? `${cuantas} × ${pesos(item.price)}`
      : pesos(item.price);

    // Lo que queda, sólo si lo manda quien sabe (la ficha, desde el inventario
    // real) y sólo si de verdad son pocas. Un «quedan 40» no informa de nada.
    const quedan = Number(detalle.quedan);
    const qNodo = q('[data-quedan]');
    if (Number.isFinite(quedan) && quedan > 0 && quedan <= POCAS) {
      qNodo.textContent = quedan === 1 ? 'Queda la última' : `Quedan ${quedan}`;
      qNodo.hidden = false;
    } else {
      qNodo.hidden = true;
    }

    this.hidden = false;
    // El siguiente cuadro, para que la transición de entrada tenga de dónde
    // salir: sin esto el panel aparece puesto, sin movimiento.
    requestAnimationFrame(() => this.setAttribute('data-abierto', ''));

    this.programarCierre();
    this.contar();
  }

  /** El número de la cesta se pregunta, no se adivina sumando. */
  async contar() {
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) return;
      const carrito = await res.json();
      const n = this.querySelector('[data-cuantas]');
      if (n) n.textContent = carrito.item_count ?? '';
    } catch {
      /* si no se puede, el enlace a la cesta funciona igual */
    }
  }

  programarCierre() {
    clearTimeout(this.reloj);
    this.reloj = setTimeout(() => this.esconder(), ESPERA);
  }

  esconder() {
    clearTimeout(this.reloj);
    this.removeAttribute('data-abierto');
    // Se espera a que acabe el fundido antes de quitarlo del todo; si alguien
    // apagó las animaciones, no hay nada que esperar.
    const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(() => { this.hidden = true; }, quieto ? 0 : 260);
  }

  disconnectedCallback() {
    clearTimeout(this.reloj);
  }
}

if (!customElements.get('sc-cart-added')) {
  customElements.define('sc-cart-added', AvisoAnadida);
}
